export default __webpack_public_path__ + "DumpertDeluxe-81dfd2.svg";